<template>
  <div class="Container">
    <div class="Header">
      <el-button type="default" @click="onClickDelete">消す</el-button>
    </div>
    <div class="Body">
      <div class="LeftColumn">
        <p class="GuideText">手書き入力エリア</p>
        <div class="Guides Guides-Overwrap">
          <div class="Guide"></div>
        </div>
        <div class="writing-container" touch-action="none" ref="editor"></div>
      </div>

      <div class="RightColumn">
        <p class="GuideText">候補文字</p>
        <div class="Guides">
          <div
            :class="[
              'ChracterCard',
              activeCharacterIndex === index && 'isActiveCharacter'
            ]"
            v-for="(item, index) in candidates"
            :key="index"
            @click="onClickOpenCandidates(index, item)"
          >
            {{ labels[index].value }}
            <div
              class="DeleteButton"
              @click.stop="onClickDeleteCandidate(index)"
            >
              <i class="el-icon-error" />
            </div>
          </div>
          <div
            class="ChracterCard"
            v-for="(item, index) in new Array(1 - candidates.length)"
            :key="String(item) + index"
          ></div>
        </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div class="Candidates" v-if="activeCandidates.length">
        <p class="GuideText">他の候補文字</p>
        <div
          :class="['ChracterCard']"
          v-for="candidate in activeCandidates"
          :key="candidate"
          @click="onClickCandidate(candidate)"
        >
          {{ candidate }}
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="Footer" v-if="activeCharacterIndex === null">
        <el-button type="primary" @click="onSelect()" class="CharacterSubmit"
          >確定</el-button
        >
      </div>
    </transition>
  </div>
</template>

<script>
import * as MyScriptJS from "myscript/src/myscript";

function __1 (val) {
  return val
    .reduce((acc, cur) => {
      console.log();
      const characters = cur.split("");
      characters.map((el, index) => {
        if (!acc[index]) {
          acc[index] = [];
        }
        acc[index].push(el);
      });
      return acc;
    }, [])
    .map(el => {
      return el.reduce((acc, cur) => {
        if (acc.filter(val => val === cur).length) {
          return acc;
        }
        acc.push(cur);
        return acc;
      }, []);
    });
}

export default {
  name: "MyScriptJSVueComponent",
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      activeCharacterIndex: null,
      activeCandidates: [],
      labels: [],
      candidates: [],
      editor: null,
      result: "",
      results: [],
    };
  },
  created () {
    // eslint-disable-next-line
    console.log("Created" + this.$refs['editor']);
  },

  methods: {
    onClickDelete () {
      // clear canvas
      this.editor.clear();
      // clear results too
      this.candidates = [];
      this.labels = [];
    },
    onClickClose () {
      this.$emit("onClose");
    },
    onSelect () {
      this.$emit("onSelect", this.labels.map(el => el.value).join(""));
      this.onClickDelete();
      this.onClickClose();
    },
    onClickOpenCandidates (index, candidates) {
      this.activeCharacterIndex = index;
      this.activeCandidates = candidates;
    },
    onClickCandidate (candidate) {
      this.labels[this.activeCharacterIndex].value = candidate;
      this.activeCharacterIndex = null;
      this.activeCandidates = [];
    },
    onClickDeleteCandidate (index) {
      this.labels = this.labels.filter((el, i) => i !== index);
      this.candidates = this.candidates.filter((el, i) => i !== index);
      this.activeCharacterIndex = null;
      this.activeCandidates = [];
    },
  },
  mounted () {
    // Fired every second, should always be true
    // eslint-disable-next-line
    console.log("Mounted " + this.$refs['editor']);
    // https://developer.myscript.com/docs/interactive-ink/1.3/web/reference/configuration-myscriptjs/

    this.$refs.editor.addEventListener("exported", evt => {
      const target =
        evt.detail.exports &&
        JSON.parse(evt.detail.exports["application/vnd.myscript.jiix"]);

      if (!target) {
        return;
      }

      // candidatesには単語単位で帰ってくるので、文字単位に分割する
      this.candidates = target.words
        .map(el => el.candidates)
        .filter(el => el)
        .reduce((acc1, word) => {
          // return __1(word);
          console.log(word);
          const filteredWords = word.filter(el => {
            // https://qiita.com/mhangyo/items/c567f93b0e20b2e6af04
            return !!el.match(/[あ-んア-ン一-鿐]/);
          });
          return [...acc1, ...__1(filteredWords)];
        }, []);
      console.log(this.candidates);

      // this.labels.splice(this.candidates.length + 1);

      this.labels = this.candidates.map((el, index) => {
        if (!el) {
          return { value: "", selected: false };
        }
        const value = el[0];
        if (!this.labels[index] || !this.labels[index].selected) {
          return {
            value,
            selected: false,
          };
        }
      });

      // this.result = evt.detail.exports["text/plain"];
    });

    this.editor = MyScriptJS.register(
      this.$refs.editor,
      {
        recognitionParams: {
          v4: {
            lang: "ja_JP",
            text: {
              guides: {
                enable: false,
              },
              smartGuide: false,
              "font-size": 50,
              "line-height": "50px",
            },
          },
          type: "TEXT",
          protocol: "WEBSOCKET",
          apiVersion: "V4",
          server: {
            scheme: "https",
            host: "webdemoapi.myscript.com",
            applicationKey: process.env.VUE_APP_MY_SCRIPT_APPLICATION_KEY,
            hmacKey: process.env.VUE_APP_MY_SCRIPT_HMAC_KEY,
          },
        },
      },
      undefined,
      {
        ink: {
          // color: "#B71C1C",
          color: "#ababab",
          // "-myscript-pen-width": 3
          "-myscript-pen-width": 1,
        },
        ".text": {
          // "font-size": 15,
          // "line-height": 15
          "font-size": 12,
          "line-height": 2.5,
        },
      }
    );
    this.editor.resize();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import url("../../node_modules/myscript/dist/myscript.min.css");

.Body {
  display: flex;
  border: 1px solid $--border-color-lighter;
}
.Body > * {
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: $turquoise-base;
}
.writing-container {
  height: 150px;
  width: 100%;
  border-right: 1px solid $--border-color-lighter;
}
.Guides-Overwrap {
  position: absolute;
}
.LeftColumn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.RightColumn {
  position: relative;
}

// .Guides {
//   /* width: 100%;
//   display: grid;
//   grid-template-columns: repeat(6, 1fr);
//   grid-template-rows: repeat(2, 110px); */
// }

.Guide {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed $--border-color-light;
  margin: auto;
}

.Guide::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 80%;
  top: 10px;
  left: 50%;
  border-right: 1px dashed $--border-color-light;
}

.Guide::after {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px;
  top: 50%;
  left: 10px;
  border-top: 1px dashed $--border-color-light;
}

.ChracterCard {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid $--border-color-light;
  margin: auto;
  font-size: 70px;
  text-align: center;
  background: white;
  line-height: 1.3;
}

.text {
  font-style: bold;
  font-weight: 800;
  color: red;
  font-size: 100;
  line-height: 2;
}
.Header {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 5px;
}
.Candidates {
  margin-top: 20px;
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: white;
  grid-gap: 10px;
  padding: 40px 0 20px 0;
  box-shadow: $shadow-color 0px 0px 2px inset;
}
.CandidatesSelect {
  margin-top: 10px;
  width: 80px;
}
// .CharacterSubmit {
// }
.Container {
  user-select: none;
  position: relative;
  margin-bottom: 10px;
}
.isActiveCharacter {
  border-color: $--color-primary;
}

.Footer {
  padding: 10px 0;
  text-align: right;
}

.DeleteButton {
  position: absolute;
  right: -15px;
  top: -15px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 50%;
}

.DeleteButton > * {
  font-size: 40px;
  color: $text-extra-light;
}
.GuideText {
  margin: 0;
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 0.8em;
  line-height: 0.8;
}
</style>
